import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { BaseForm } from "../../../../components/Form";
import { signupFormConfig, COUNTRIES, getDialFromSelectValue, getDialSelectValue } from "./config/signUp.config";
import { signUpFormStyles } from "./config/signUpStyles.config";
import { usePostSignUp } from "./hooks/usePostSignUp";
import { useGlobalSnackbar } from "../../../../context/SnackbarContext";
import { getBasePath } from "../../../../utils";
import { useSelector } from "react-redux";
import type { TFormValues } from "../../../../components/Form/types/form.types";

export const SignUpMainLayout = () => {
    const navigate = useNavigate();
    const { mutateAsync: postSignUp } = usePostSignUp();
    const { showSnackbar } = useGlobalSnackbar();
    const userState = useSelector((state: any) => state.userState);
    const basePath = getBasePath(userState.roles?.[0]?.type || "");

    return (
        <Box sx={{ padding: 2 }}>
            <BaseForm
                fields={signupFormConfig.fields}
                columns={signupFormConfig.columns}
                submitLabel={signupFormConfig.submitLabel}
                styles={signUpFormStyles}
                onFieldChange={(name, value, updateField) => {
                    if (name === "country" && typeof value === "string") {
                        const entry = COUNTRIES.find((c) => c.name === value);
                        if (entry) {
                            updateField("countryCode", entry.code);
                            updateField("dialCode", getDialSelectValue(entry));
                        }
                    }
                }}
                onSubmit={async (data) => {
                    try {
                        const payload: TFormValues = {
                            ...data,
                            dialCode: getDialFromSelectValue(data.dialCode as string),
                        };

                        await postSignUp(payload);
                        showSnackbar("Account created successfully.", "success", 4000, "bottom-left");
                        navigate(basePath);
                    } catch (error: any) {
                        const errorMessage = error.response?.data?.error || error.response?.data?.message || "Something went wrong. Please try again.";
                        showSnackbar(errorMessage, "error", 4000, "bottom-left");
                    }
                }}
            />
        </Box>
    );
};
